// Утилиты для работы с различиями между организациями

/**
 * Получить термин для специализации в зависимости от организации
 * МАГ: "Специализация"
 * Наследие: "Авторская программа"
 */
export const getSpecializationTerm = (orgCode) => {
    return orgCode === 'nasledie' ? 'Авторская программа' : 'Специализация';
};

/**
 * Получить префикс направления для специализации
 * МАГ: "Специализация:"
 * Наследие: "Авторская программа:"
 */
export const getSpecializationPrefix = (orgCode) => {
    return orgCode === 'nasledie' ? 'Авторская программа:' : 'Специализация:';
};

/**
 * Проверить, является ли направление специализацией/авторской программой
 */
export const isSpecializationDirection = (directionName, orgCode) => {
    if (!directionName) return false;
    const prefix = getSpecializationPrefix(orgCode);
    return directionName.startsWith(prefix);
};

/**
 * Получить название специализации без префикса
 */
/** Как в интерфейсе называется запись directions: у МАГ это модуль. */
export const getDirectionTerms = (orgCode) => {
    if (orgCode === 'nasledie') {
        return {
            one: 'Направление',
            many: 'Направления',
            oneLower: 'направление',
            manyLower: 'направления',
            manyGen: 'направлений',
            oneGen: 'направления',
            deleted: 'Направление удалено',
            updated: 'Направление обновлено',
            created: 'Направление создано',
            notFound: 'Направление не найдено'
        };
    }
    return {
        one: 'Модуль',
        many: 'Модули',
        oneLower: 'модуль',
        manyLower: 'модули',
            manyGen: 'модулей',
            oneGen: 'модуля',
        deleted: 'Модуль удалён',
        updated: 'Модуль обновлён',
            created: 'Модуль создан',
            notFound: 'Модуль не найден'
    };
};

export const getSpecializationName = (directionName, orgCode) => {
    if (!directionName) return '';
    const prefix = getSpecializationPrefix(orgCode);
    return directionName.startsWith(prefix)
        ? directionName.replace(prefix, '').trim()
        : directionName;
};

